import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MosaicCardMask = styled.div<React.CSSProperties>`
  background: linear-gradient(
    7deg,
    rgba(0, 0, 0, 0.9) 16.82%,
    rgba(0, 0, 0, 0) 43.26%
  );
  border-radius: ${20 * Screen.widthRatio}px;
  height: ${200 * Screen.widthRatio}px;
  position: absolute;
  width: ${350 * Screen.widthRatio}px;
`;

export default MosaicCardMask;
